import React from 'react'

export const Overlay = ({ children }) =>
  <div className='centered-overlay' >
      {children}
  </div>
